import { BAVEL_PATH } from './app-config';
import { BAVEL_ROLES } from './app-roles';
import { environment } from 'environments/environment';

export const FALCON_URLS = {
    baseUrl: environment.urls.falcon,
    paths: {
        RECEIVED_DOCUMENTS: '/DigitalData/ReceivedDocuments.aspx',
        AVAILABLE_DOWNLOADS: '/Download/usrDownloads.aspx',
        WEBBILLING_CREATE_INVOICE: '/WebBilling/TravelBilling.aspx',
        HORECA_WEBBILLING_MANUAL_INVOICE: '/WebBilling/HorecaBilling.aspx',
        WEBBILLING_IMPORT_INVOICE: '/Imports/usrPending.aspx',
        HORECA_WEBBILLING_IMPORT_INVOICE: '/ImportsHoreca/usrPendingHoreca.aspx',
        CATALOGUE_FAMILIES: '/Catalogue/Families.aspx',
        ADV_CATALOGUE_VIEW: '/CatalogueImport/CatalogueView.aspx',
        ROLLOUT_STATUS: '/BusinessData/RolloutStatus.aspx',
        ROLLOUT_MATCHING_LEGACY: '/PreRegManager/PreRegPending.aspx',
        LOGIN_MANAGER: '/BusinessData/LoginManager.aspx',
        CONTRACTS: '/Contracts/Contracts.aspx'
    }
};

export const EXTRANETJS_URLS = {
    paths: {
        PREFERENCES: `${environment.urls.partnerPortal}/preferences/user`,
        TPN_CUSTOMER_EBILLING_GLOBALSTATUS: `${environment.urls.extranetJS}/tpn/customer/eBilling/globalStatus`,
        TPN_CUSTOMER_VCC_GLOBALSTATUS: `${environment.urls.extranetJS}/tpn/customer/vcc/globalStatus`,
        TPN_SUPPLIER_EBILLING_GLOBALSTATUS: `${environment.urls.extranetJS}/tpn/supplier/eBilling/globalStatus`,
        TPN_SUPLIER_VCC_GLOBALSTATUS: `${environment.urls.extranetJS}/tpn/supplier/vcc/globalStatus`,
    }
};

export const PARTNER_PORTAL_URLS = {
    baseUrl: environment.urls.partnerPortal,
    paths: {
        DIGITAL_ARCHIVE: '/digital-archive',
    }
};

export interface BavelSubMenu {
    id: string;
    url: string;
    allowedRoles?: string[];
    token: string;
    show: boolean;
}

export interface BavelMenu {
    id: string;
    token: string;
    iconClass: string | undefined;
    allowedRoles: string[];
    url?: string;
    route?: string | undefined;
    old: boolean;
    pageTitle?: string;
    iconTitleSrc?: string;
    subMenuOptions?: BavelSubMenu[];
    faIcon?: string;
    hidden?: boolean;
    showSubMenu?: boolean;
}

export interface DashboardMenu {
    id: string;
    title: string;
    description: string;
    allowedRoles: string[];
    class: string;
    url?: string;
    hidden?: boolean;
}

export const DASHBOARD_OPTIONS: DashboardMenu[] = [

    {
        id: 'DIGITAL_ARCHIVE',
        title: 'Dashboard_Cards_DigitalArchive_Title',
        description: 'Dashboard_Cards_AllInvoicesDeliveryNotesAndOtherTransactionalDocuments_Title',
        allowedRoles: [
            BAVEL_ROLES.FN_DA_RECEIVED_DOCUMENTS,
            BAVEL_ROLES.FN_DA_SENT_DOCUMENTS,
            BAVEL_ROLES.FN_DA_WEB_CFUE
        ],
        class: 'digital-archive',
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.RECEIVED_DOCUMENTS
    },
    {
        id: 'TRAVEL_WEBBILLING',
        title: 'Dashboard_Cards_NewInvoice_Title',
        description: 'Dashboard_Cards_CreateAndSendInvoices_Title',
        allowedRoles: [
            BAVEL_ROLES.FN_WBT_MANUAL_INVOICE
        ],
        class: 'invoice',
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.WEBBILLING_CREATE_INVOICE
    },
    {
        id: 'TRAVEL_WEBBILLING',
        title: 'Dashboard_Cards_NewInvoice_Title',
        description: 'Dashboard_Cards_CreateAndSendInvoices_Title',
        allowedRoles: [
            BAVEL_ROLES.FN_WBT_MANUAL_INVOICE
        ],
        class: 'invoice',
        url: BAVEL_PATH.WEBBILLING_TRAVEL,
        hidden: environment.production
    },
    {
        id: 'HORECA_WEBBILLING',
        title: 'Dashboard_Cards_NewInvoice_Title',
        description: 'Dashboard_Cards_CreateAndSendInvoices_Title',
        allowedRoles: [
            BAVEL_ROLES.FN_WBH_MANUAL_INVOICE,
            BAVEL_ROLES.FN_WBH_AUTO_DN,
            BAVEL_ROLES.FN_WBEPROC_MANUAL_INVOICE,
        ],
        class: 'invoice',
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.HORECA_WEBBILLING_MANUAL_INVOICE
    },
    {
        id: 'TRAVEL_WEBBILLING_IMPORT',
        title: 'Dashboard_Cards_UploadInvoice_Title',
        description: 'Dashboard_Cards_UploadInvoiceFilesToPlatform_Title',
        allowedRoles: [
            BAVEL_ROLES.FN_WBT_MANUAL_INVOICE,
            BAVEL_ROLES.FN_WBT_IMPORT_INVOICE
        ],
        class: 'upload',
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.WEBBILLING_IMPORT_INVOICE
    },
    {
        id: 'HORECA_WEBBILLING_IMPORT',
        title: 'Dashboard_Cards_UploadInvoice_Title',
        description: 'Dashboard_Cards_UploadInvoiceFilesToPlatform_Title',
        allowedRoles: [
            BAVEL_ROLES.FN_WBH_MANUAL_INVOICE,
            BAVEL_ROLES.FN_WBH_AUTO_DN,
            BAVEL_ROLES.FN_WBH_IMPORT_INVOICE,
            BAVEL_ROLES.FN_WBEPROC_MANUAL_INVOICE,
            BAVEL_ROLES.FN_WBEPROC_IMPORT_INVOICE
        ],
        class: 'upload',
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.HORECA_WEBBILLING_IMPORT_INVOICE
    },
    {
        id: 'EPAYMENTS',
        title: 'Dashboard_Cards_PaymentManager_Title',
        description: 'Dashboard_Cards_ManagePaymentOperations_Title',
        allowedRoles: [
            BAVEL_ROLES.FN_EPAYMENTS_SUPPLIER,
        ],
        class: 'payment',
        url: BAVEL_PATH.BAVEL_COLLECT_TRAVEL
    },
    {
        id: 'EPAYMENTS',
        title: 'Dashboard_Cards_PaymentManager_Title',
        description: 'Dashboard_Cards_ManagePaymentOperations_Title',
        allowedRoles: [
            BAVEL_ROLES.EPAYMENTS_CLIENT_TRAVEL,
        ],
        class: 'payment',
        url: BAVEL_PATH.BAVELPAY_TRAVEL
    }
];

export const MENU_ID = {
    DIGITAL_ARCHIVE: 'DIGITAL_ARCHIVE',
    NEW_DIGITAL_ARCHIVE: 'NEW_DIGITAL_ARCHIVE',
    NEW_WEBBILLING: 'NEW_WEBBILLING',
    HORECA_WEBBILLING: 'HORECA_WEBBILLING'
};

export const BAVEL_APP_MENUS: BavelMenu[] = [
    {
        id: MENU_ID.NEW_DIGITAL_ARCHIVE,
        token: 'Menu_menuItem_DigitalArchive',
        iconClass: 'bg-icon-digital-archive',
        allowedRoles: [
            BAVEL_ROLES.FN_DA_RECEIVED_DOCUMENTS,
            BAVEL_ROLES.FN_DA_SENT_DOCUMENTS,
            BAVEL_ROLES.FN_DA_WEB_CFUE
        ],
        url: PARTNER_PORTAL_URLS.baseUrl + PARTNER_PORTAL_URLS.paths.DIGITAL_ARCHIVE,
        old: false,
        pageTitle: 'Menu_menuItem_DigitalArchive',
        hidden: environment.production
    },
    {
        id: MENU_ID.DIGITAL_ARCHIVE,
        token: 'Menu_menuItem_DigitalArchive',
        iconClass: 'bg-icon-digital-archive',
        allowedRoles: [
            BAVEL_ROLES.FN_DA_RECEIVED_DOCUMENTS,
            BAVEL_ROLES.FN_DA_SENT_DOCUMENTS,
            BAVEL_ROLES.FN_DA_WEB_CFUE
        ],
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.RECEIVED_DOCUMENTS,
        old: true
    }, {
        id: 'DOWNLOAD_AREA',
        token: 'Menu_MenuItem_Download',
        iconClass: 'bg-icon-downloads',
        allowedRoles: [
            BAVEL_ROLES.FN_DL_AVAILABLE_DL,
            BAVEL_ROLES.FN_DL_PENDING_RQ,
            BAVEL_ROLES.FN_DL_DELETED
        ],
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.AVAILABLE_DOWNLOADS,
        old: true
    }, {
        id: MENU_ID.NEW_WEBBILLING,
        token: 'Menu_MenuItem_Webbilling',
        iconClass: 'bg-icon-ebilling',
        allowedRoles: [
            BAVEL_ROLES.FN_WBT_MANUAL_INVOICE,
            BAVEL_ROLES.FN_WBT_IMPORT_INVOICE
        ],
        pageTitle: 'Menu_MenuItem_Webbilling_CreateInvoice',
        iconTitleSrc: '/assets/images/icons/icon-webbilling-new-invoice-title.png',
        url: BAVEL_PATH.WEBBILLING_TRAVEL,
        old: false,
        hidden: environment.production
    }, {
        id: 'TRAVEL_WEBBILLING',
        token: 'Menu_MenuItem_Webbilling',
        iconClass: 'bg-icon-ebilling',
        allowedRoles: [
            BAVEL_ROLES.FN_WBT_MANUAL_INVOICE,
            BAVEL_ROLES.FN_WBT_IMPORT_INVOICE
        ],
        iconTitleSrc: '/assets/images/icons/icon-webbilling-new-invoice-title.png',
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.WEBBILLING_CREATE_INVOICE,
        old: true,
    }, {
        id: MENU_ID.HORECA_WEBBILLING,
        token: 'Menu_MenuItem_Webbilling',
        iconClass: 'bg-icon-ebilling',
        allowedRoles: [
            BAVEL_ROLES.FN_WBH_MANUAL_INVOICE,
            BAVEL_ROLES.FN_WBH_AUTO_DN,
            BAVEL_ROLES.FN_WBH_IMPORT_INVOICE,
            BAVEL_ROLES.FN_WBEPROC_MANUAL_INVOICE,
            BAVEL_ROLES.FN_WBEPROC_IMPORT_INVOICE],
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.HORECA_WEBBILLING_MANUAL_INVOICE,
        old: true
    }, {
        id: 'CATALOGUE',
        token: 'Menu_MenuItem_Catalogue',
        iconClass: 'bg-icon-catalogue',
        allowedRoles: [
            BAVEL_ROLES.FN_CTLG_FAMILIES,
            BAVEL_ROLES.FN_CTLG_CATALOGUES,
            BAVEL_ROLES.FN_CTLG_PRICE_LIST
        ],
        old: true,
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.CATALOGUE_FAMILIES
    }, {
        id: 'ADVANCED_CATALOGUE',
        token: 'Menu_MenuItem_AdvanceCatalogue',
        iconClass: 'bg-icon-catalogue',
        allowedRoles: [
            BAVEL_ROLES.FN_ADV_CTLG_CATALOGUE,
            BAVEL_ROLES.FN_ADV_CTLG_IMPORT
        ],
        old: true,
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.ADV_CATALOGUE_VIEW
    },
    {
        id: 'ROLLOUT_STATUS',
        token: 'Menu_MenuItem_RolloutStatus',
        iconClass: undefined,
        faIcon: 'fa-list-alt',
        allowedRoles: [BAVEL_ROLES.FN_ROLLOUT_STATUS],
        old: true,
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.ROLLOUT_STATUS
    }, {
        id: 'ROLLOUT_MANAGEMENT',
        token: 'Menu_MenuItem_RolloutManagement',
        iconClass: undefined,
        faIcon: 'fa-list-alt',
        allowedRoles: [
            BAVEL_ROLES.FN_ROLLOUT_MATCHING_LEGACY,
            BAVEL_ROLES.FN_ROLLOUT_VOUCHER_SENT,
            BAVEL_ROLES.FN_ROLLOUT_TEMPLATE_EDIT
        ],
        old: true,
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.ROLLOUT_MATCHING_LEGACY
    }, {
        id: 'LOGIN_MANAGER',
        token: 'Menu_MenuItem_Login_Manager',
        iconClass: 'bg-icon-admin-login',
        allowedRoles: [BAVEL_ROLES.FN_LOGIN_MANAGER],
        old: true,
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.LOGIN_MANAGER
    }, {
        id: 'CONTRACTS',
        token: 'Menu_MenuItem_Contracts',
        iconClass: 'bg-icon-contracts',
        allowedRoles: [BAVEL_ROLES.FN_CONTRACTS],
        old: true,
        url: FALCON_URLS.baseUrl + FALCON_URLS.paths.CONTRACTS
    }, {
        id: 'TPN',
        token: 'Menu_MenuItem_TradingPartnerNetwork',
        iconClass: 'bg-icon-network',
        allowedRoles: [
            BAVEL_ROLES.FN_TPN_EBILLING_SUPPLIER,
            BAVEL_ROLES.FN_TPN_EBILLING_CLIENT,
            BAVEL_ROLES.FN_TPN_VCC_CLIENT,
            BAVEL_ROLES.FN_TPN_VCC_SUPPLIER
        ],
        old: true,
        url: EXTRANETJS_URLS.paths.TPN_SUPPLIER_EBILLING_GLOBALSTATUS,
        showSubMenu: true,
        subMenuOptions: [{
            id: 'EBILLING_SUPPLIER',
            url: EXTRANETJS_URLS.paths.TPN_SUPPLIER_EBILLING_GLOBALSTATUS,
            allowedRoles: [BAVEL_ROLES.FN_TPN_EBILLING_SUPPLIER],
            token: 'Menu_MenuItem_Tpn_Supplier',
            show: false
        },
        {
            id: 'EBILLING_CLIENT',
            url: EXTRANETJS_URLS.paths.TPN_CUSTOMER_EBILLING_GLOBALSTATUS,
            allowedRoles: [BAVEL_ROLES.FN_TPN_EBILLING_CLIENT],
            token: 'Menu_MenuItem_Tpn_Client',
            show: false
        },
        {
            id: 'VCC_CLIENT',
            url: EXTRANETJS_URLS.paths.TPN_CUSTOMER_VCC_GLOBALSTATUS,
            allowedRoles: [BAVEL_ROLES.FN_TPN_VCC_CLIENT],
            token: 'Menu_MenuItem_TradingPartnerNetwork',
            show: false
        },
        {
            id: 'VCC_SUPPLIER',
            url: EXTRANETJS_URLS.paths.TPN_SUPLIER_VCC_GLOBALSTATUS,
            allowedRoles: [BAVEL_ROLES.FN_TPN_VCC_SUPPLIER],
            token: 'Menu_MenuItem_TradingPartnerNetwork',
            show: false
        }
        ]
    },
    {
        id: 'EPAYMENTS',
        token: 'Menu_MenuItem_EPayments',
        iconClass: 'bg-icon-payments',
        allowedRoles: [
            BAVEL_ROLES.FN_EPAYMENTS_SUPPLIER,
        ],
        old: false,
        pageTitle: 'Menu_MenuItem_EPayments',
        url: BAVEL_PATH.BAVEL_COLLECT_TRAVEL
    },
    {
        id: 'EPAYMENTS-TRAVEL',
        token: 'Menu_MenuItem_EPayments',
        iconClass: 'bg-icon-payments',
        allowedRoles: [
            BAVEL_ROLES.EPAYMENTS_CLIENT_TRAVEL,
        ],
        old: false,
        pageTitle: 'Menu_MenuItem_EPayments',
        url: BAVEL_PATH.BAVELPAY_TRAVEL
    },
    {
        id: 'BILLBACK_RECEIVED',
        token: 'Billback_Manager_Title',
        iconClass: 'bg-icon-billback-manager',
        allowedRoles: [
            BAVEL_ROLES.BILLBACK_RECEIVED
        ],
        pageTitle: 'Billback_Manager_Title',
        old: false,
        url: BAVEL_PATH.BILLBACK_RECEIVED
    },
    {
        id: 'BILLBACK_SENT',
        token: 'Billback_Manager_Title',
        iconClass: 'bg-icon-billback-manager',
        allowedRoles: [
            BAVEL_ROLES.BILLBACK_SENT
        ],
        pageTitle: 'Billback_Manager_Title',
        old: false,
        url: BAVEL_PATH.BILLBACK_SENT
    },
    {
        id: 'PDF_BILLING',
        token: 'Menu_menuItem_PdfBilling',
        iconClass: 'bg-icon-pdf-billing',
        allowedRoles: [
            BAVEL_ROLES.PDF_BILLING
        ],
        pageTitle: 'Menu_menuItem_PdfBilling',
        old: false,
        url: BAVEL_PATH.PDF_BILLING
    }
];
